'use client';

import ReactModal from 'react-modal';

export type ModalProps = ReactModal.Props;

// TODO: モーダルのデザインFIX後にスタイルの調整
const defaultModalStyle = {
  content: {
    top: '50%',
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    padding: '0', // デフォルトの打ち消し
    border: 'none', // デフォルトの打ち消し
    backgroundColor: 'var(--fds-color-layer-background-02, #fff)',
    borderRadius: 'var(--fds-border-radius-m, 8px)',
  },
  overlay: {
    backgroundColor: 'var(--fds-color-background-overlay, rgba(0, 0, 0, 0.8))',
    zIndex: 1031, // Header の zIndex が 1030 なのでそれより上にする
  },
};

export const ModalBase = ({ children, ...rest }: ModalProps) => {
  return (
    <ReactModal
      ariaHideApp={false}
      // モーダルが入力項目を持つとき、誤って閉じてしまうと再入力する必要が生まれる
      // モーダルは閉じても入力状態を保持する という共通認識を持つのはまだ難しいためデフォルトで false にし、閉じないようにしています
      shouldCloseOnOverlayClick={false}
      style={defaultModalStyle}
      {...rest}
    >
      <section style={{ borderRadius: 'inherit' }}>{children}</section>
    </ReactModal>
  );
};
